import type { HttpTransport } from "@common/api/transport";
import type Currency from "@common/types/Currency";
import type { CurrencyCheckResult } from "@common/types/User";

export const createCurrenciesApi = (http: HttpTransport) => ({
  fetchCurrencies: () => http.get<{ currencies: Currency[] }>("/api/currencies"),

  fetchCurrencyCheck: () => http.get<CurrencyCheckResult>("/api/currencies/check")
});
